<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">{{ info?.story_form_title }}</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content class="card-content">
  <form class="form-container" [formGroup]="descForm" (ngSubmit)="submit(descForm.value)" autocomplete="off">
    <app-editor class="editor" [group]="descForm"
                [control]="desc"
                [draftId]="draft?.id"
                [draftData]="draft"
                (focusout)="updateInfoDraft()"
                [info]="info" >
    </app-editor>
    <button id="descSubmitBtn" style="display: none" ></button>
    <div class="info">
      <div class="checkbox-wrapper">
        <mat-checkbox color="primary" [formControl]="termsCondition">
        </mat-checkbox>
        <div *ngIf="util.storage.get('language') === 'Hindi' ; else privacy">
          <div class="story-footer">
            मैं केटो की
            <a class="primary-color" target="_blank" [href]="origin + '/terms-of-use.php'" queryParamsHandling="merge">{{ info?.terms_of_use}}</a>,
            <a class="primary-color" target="_blank" [href]="origin + '/privacy-policy.php'"  queryParamsHandling="merge">{{ info?.privacy_policy}}</a>
            सेवा अनुबंध (
            <a class="primary-color" target="_blank" href="https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoUSAserviceagreement.pdf" queryParamsHandling="merge"> USA</a>
            और
            <a class="primary-color" target="_blank" [href]="isPersonalCampaign ?'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaServiceagreementForPersonal.pdf':'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaserviceagreement.pdf'" queryParamsHandling="merge"> India</a> ),
            <a class="primary-color" target="_blank" [href]="origin + '/support/plans-and-pricing.php'"  queryParamsHandling="merge">{{ info?.plans_and_pricing}}</a>
            <span *ngIf="isPersonalCampaign">
              और मेडीबुड्डी फ़ायदे
            </span>
            के लिए सहमत हूं।
            {{info?.acknowledge}}
          </div>
        </div>
        <ng-template #privacy>
          <div class="story-footer">
            {{info?.iAgree  }}
            <a class="primary-color" target="_blank" [href]="origin + '/terms-of-use.php'" queryParamsHandling="merge"> {{ info?.terms_of_use}}</a>,
            {{ info?.serviceAgreement }} (
            <a class="primary-color" target="_blank" href="https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoUSAserviceagreement.pdf" queryParamsHandling="merge"> USA</a>
              {{info?.and  }}
            <a class="primary-color" target="_blank" [href]="isPersonalCampaign ? 'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaServiceagreementForPersonal.pdf': 'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaserviceagreement.pdf'" queryParamsHandling="merge"> India</a> ),
            <a class="primary-color" target="_blank" [href]="origin + '/privacy-policy.php'"  queryParamsHandling="merge">{{ info?.privacy_policy}} &nbsp;</a> 
            <span *ngIf="!isPersonalCampaign">
              {{ info?.and }}
            </span>
            <a class="primary-color" target="_blank" [href]="origin + '/support/plans-and-pricing.php'"  queryParamsHandling="merge">{{ info?.plans_and_pricing}}</a>
            {{info?.acknowledge}}
          </div>
        </ng-template>
      </div>
    </div>
  </form>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{getText()}}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</mat-card-footer>

<!-- info modal -->
<ng-template #infoDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content class="infoDialog" [innerHTML]="info?.description_story?.popover?.placeholder">
    </mat-dialog-content>
    <mat-dialog-actions class="btn-container">
      <button mat-button class="dialog-btn back-btn" color="primary" (click)="closeDialog()">
        <mat-icon matPrefix>chevron_left</mat-icon> {{info?.back}}
      </button>
      <button mat-button class="dialog-btn assist-btn" color="primary" (click)="getAssist()" cdkFocusInitial>
        {{info?.get_assistance}}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!-- success modal -->
<ng-template #successDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content>
      <div class="text-center">
        <img loading="lazy" data-src="/assets/images/done.png" alt="done_image">
        <div class="assist-text">
          We have sent a request to your fundraiser <br> expert.
          We'll get back to you shortly. <br>You can also call us at
          <a class="text-primary" [href]="'tel:' + vars?.contactUsMobNumber">+91 {{ vars?.contactUsMobNumber }}</a>
        </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-container">
      <button mat-button class="dialog-btn ok-btn" color="primary" (click)="closeDialog()">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>